import { useMemo } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { UserPlus } from 'lucide-react'
import { PageHeader } from '@/components/page-header'
import { Button } from '@/components/ui/button'
import { ClientList } from '@/features/clients/client-list'
import { usePermission } from '@/lib/permissions'
import { requirePermission } from '@/lib/route-guards'
import { ROUTES } from '@/lib/routes'
import { useShortcuts, type ShortcutDef } from '@/lib/shortcuts'

export const Route = createFileRoute('/_app/clients/')({
  beforeLoad: requirePermission('clients:read'),
  component: ClientsIndexPage,
})

/** Listado de clientes con acceso al registro. */
function ClientsIndexPage() {
  const navigate = useNavigate()
  const canWrite = usePermission('clients:write')
  const shortcuts = useMemo<ShortcutDef[]>(
    () =>
      canWrite
        ? [{ id: 'client-new', group: 'Acciones', keys: ['N'], sequence: ['n'], label: 'Nuevo cliente', run: () => void navigate({ to: ROUTES.newClient }) }]
        : [],
    [canWrite, navigate],
  )
  useShortcuts(shortcuts)

  return (
    <div className="space-y-6">
      <PageHeader
        title="Clientes"
        description="Registro, ficha y cartera de cada cliente."
        actions={
          canWrite && (
            <Button onClick={() => void navigate({ to: ROUTES.newClient })}>
              <UserPlus /> Nuevo cliente
            </Button>
          )
        }
      />
      <ClientList />
    </div>
  )
}
